import { useEffect, useRef, useState } from 'react';

// Maps semantic helpId names to CSS selectors for elements that can't have
// data-help-id directly (rendered by third-party components like Ant Design).
// Update this list as new aliased elements are added to the help content.
const SELECTOR_ALIASES = {
  'order-select':    '.ant-table-selection-column',
  'pin-icon':        '[class*="anticon-pushpin"]',
  'column-header':   '.table-header-column',
  'files-pdf-tab':   '[data-node-key="html"]',
  'files-xls-tab':   '[data-node-key="xls"]',
  'log-expand':      '.ant-table-row-expand-icon',
  'nav-orders':      '.ant-menu-item a[href="/orders"]',
  'nav-files':       '.ant-menu-item a[href="/files"]',
  'nav-log':         '.ant-menu-item a[href="/log"]',
  'nav-notifications': '.ant-menu-item a[href="/notifications"]',
};

const HelpSpotlight = () => {
  const [rect, setRect] = useState(null);
  const channelRef = useRef(null);
  const timerRef   = useRef(null);

  useEffect(() => {
    channelRef.current = new BroadcastChannel('innocoso-help');

    channelRef.current.onmessage = (e) => {
      if (e.data?.type !== 'spotlight') return;
      const { helpId } = e.data;

      const selector = SELECTOR_ALIASES[helpId]
        ? SELECTOR_ALIASES[helpId]
        : `[data-help-id="${helpId}"]`;

      const el = document.querySelector(selector);

      if (!el) {
        // Element not in DOM — modal may be closed or page hasn't rendered it yet.
        // Send the miss back so the help window can show a contextual hint.
        channelRef.current?.postMessage({ type: 'spotlight-miss', helpId });
        return;
      }

      // Cancel any in-flight timer from a previous message
      clearTimeout(timerRef.current);

      // Scroll element into view, then snapshot rect after scroll settles
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });

      timerRef.current = setTimeout(() => {
        const r = el.getBoundingClientRect();
        setRect({ top: r.top - 6, left: r.left - 6, width: r.width + 12, height: r.height + 12 });
        // Auto-dismiss after 8s — long enough to switch windows and locate the element
        timerRef.current = setTimeout(() => setRect(null), 8000);
      }, 250);
    };

    return () => {
      channelRef.current?.close();
      clearTimeout(timerRef.current);
    };
  }, []);

  if (!rect) return null;

  return (
    <div
      onClick={() => { clearTimeout(timerRef.current); setRect(null); }}
      style={{
        position: 'fixed',
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        boxShadow: '0 0 0 9999px rgba(0,0,0,0.62)',
        borderRadius: 6,
        border: '2px solid #4fc3f7',
        zIndex: 9998,
        cursor: 'pointer',
        pointerEvents: 'auto',
        transition: 'top 0.2s ease, left 0.2s ease, width 0.2s ease, height 0.2s ease',
      }}
    />
  );
};

export default HelpSpotlight;
